import store from '@/store';

export default class ClientChatTypingEvent {
  constructor(event) {
    store.dispatch('jobs/clientChatTyping', event);
    store.dispatch('jobs/alterClientStatusChat', event);
  }
}
